import axios from 'axios';

import lstModules from 'common/json/lstModules.json';

const httpURL = lstModules['main'].url + ':' + lstModules['main'].port;
const tokenid = localStorage.getItem("tokenid");




export const getPanelListSvc = (callback) => {
    // console.log("getPanelListSvc called");
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/panel/list',
        method: "POST",
        headers: { 'tokenid': tokenid },
        withCredentials: true,
    }).then((response) => {
        // console.log('response in getPanelListSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.lstPanel = response.data.lstPanel;
        }
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}


export const savePanelSvc = (panelObj, callback) => {
    // console.log("savePanelSvc called, panelObj", panelObj);
    const formData = new FormData();
    formData.append("panelObj", JSON.stringify(panelObj));
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/panel/save',
        method: "POST",
        headers: { 'tokenid': tokenid },
        data: formData,
        withCredentials: true,
    }).then((response) => {
        // console.log('response in savePanelSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.panelId = response.data.panelId;
        }
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}



export const addPanelContentSvc = (panelContentObj, callback) => {
    // console.log("addPanelContentSvc called, panelContentObj", panelContentObj);
    const formData = new FormData();
    formData.append("panelContentObj", JSON.stringify(panelContentObj));
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/panel/add_panel_content',
        method: "POST",
        headers: { 'tokenid': tokenid },
        data: formData,
        withCredentials: true,
    }).then((response) => {
        // console.log('response in addPanelContentSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}



export const setPanelContentTimeSvc = (panelContentObj, callback) => {
    // console.log("setPanelContentTimeSvc called, panelContentObj", panelContentObj);
    const formData = new FormData();
    formData.append("panelContentObj", JSON.stringify(panelContentObj));
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/panel/set_display_time',
        method: "POST",
        headers: { 'tokenid': tokenid },
        data: formData,
        withCredentials: true,
    }).then((response) => {
        // console.log('response in setPanelContentTimeSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}

export const panelContentListSvc = (panelId, callback) => {
    // console.log("panelContentListSvc called, panelId", panelId);
    const formData = new FormData();
    formData.append("panelId", panelId);
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/panel/list_panel_content',
        method: "POST",
        headers: { 'tokenid': tokenid },
        data: formData,
        withCredentials: true,
    }).then((response) => {
        // console.log('response in panelContentListSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.lstContent = response.data.lstContent;
        }
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}


export const deletePanelSvc = (panelId, callback) => {
    // console.log("deletePanelSvc called, panelId", panelId);
    const formData = new FormData();
    formData.append("panelId", panelId);
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/panel/delete',
        method: "POST",
        headers: { 'tokenid': tokenid },
        data: formData,
        withCredentials: true,
    }).then((response) => {
        // console.log('response in deletePanelSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}


function slideShowPanel(panelId, cb) {
    // console.log("slideShowPanel called, panelId", panelId);
    var status = 'Success'
    var obj = { status: status, message: '', panelId:panelId };
    axios({
        url: httpURL + '/sms/panel/play',
        method: 'POST',
        params: { panelId: panelId },
        headers: { tokenid: tokenid },
        withCredentials: true
    })
        .then(response => {
            // console.log("response in slideShowPanel: ", response);
            if (response.data.SvcStatus === 'Success') {
                obj.message = ''
                obj.status = 'Success'
                obj.contentBasePath = response.data.contentBasePath
                obj.lstPanelPlayContent = response.data.lstPanelPlayContent
                cb(obj)
            } else {
                obj.status = 'Failure'
                obj.message = response.data.SvcMsg
                cb(obj)
            }
        })
        .catch(error => {
            obj.status = 'Exception'
            obj.message = error
            cb(obj)
        })

}
export { slideShowPanel }
